import caution from "@/assets/svgs/caution.svg";
import confetti from "@/assets/svgs/confetti.svg";
import check from "@/assets/svgs/check.svg";
import { ProjectApi } from "@/types";

interface MailingListInfoProps {
  icon?: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
  title: string;
  subtitle: string;
}

export const postSubmitData: Record<
  ProjectApi.B2CAccount.NewsletterSubscribe.Response,
  MailingListInfoProps
> = {
  SUCCESS: {
    icon: check,
    title: "Thanks for subscribing!",
    subtitle: "You’ll receive an email to confirm your subscription.",
  },
  ERROR: {
    icon: caution,
    title: "Something isn’t right here",
    subtitle: "Please reload the page and try again.",
  },
  EXISTS: {
    icon: confetti,
    title: "You’re already subscribed!",
    subtitle:
      "We’re happy you’re interested in Sprint. You’ll get notifications when we send out emails.",
  },
};
